import { useGetAiAgentProfilesForPortalQuery } from '../../../../__generated__/chirp/com/hubspot/cv/ai/agents/configuration/rpc/AiAgentService.hooks';

export const useHasCustomerAgent = (): boolean => {
  const { data, loading: loadingCustomerAgent } =
    useGetAiAgentProfilesForPortalQuery({ variables: { pageLength: 1 } });

  const hasCustomerAgent = (data?.results?.length ?? 0) > 0;

  return Boolean(!loadingCustomerAgent && hasCustomerAgent);
};
